import * as Sentry from "@sentry/react";
import { MutationCache, QueryCache, QueryClient } from "@tanstack/react-query";

import { isServerError } from "@/utils/isServerError";
import { shouldRetryQuery } from "@/utils/shouldRetryQuery";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      retry: shouldRetryQuery,
    },
  },
  queryCache: new QueryCache({
    onError: (error) => {
      if (isServerError(error)) {
        Sentry.captureException(error);
      }
    },
  }),
  mutationCache: new MutationCache({
    onError: (error) => {
      if (isServerError(error)) {
        Sentry.captureException(error);
      }
    },
  }),
});
